import moment from 'moment';
import * as yup from 'yup';

export default function useBulkDownloadDocumentsFormSteps({
  allData,
  initialInsuredIds,
  initialDocumentIds,
  initialDocuments
}) {
  const formSteps = [
    {
      name: 'Select Date',
      initialValues: {
        activeOn: moment().startOf('day'),
        initialData: allData,
        initialInsuredIds: initialInsuredIds || [],
        initialDocumentIds: initialDocumentIds || [],
        initialDocuments: initialDocuments || []
      },
      validationSchema: yup.object().shape({
        activeOn: yup.date().required('Required'),
        initialData: yup.array(),
        initialInsuredIds: yup.array(),
        initialDocumentIds: yup.array(),
        initialDocuments: yup.array()
      })
    },
    {
      name: 'Include Stakeholder Documents',
      initialValues: {
        includeStakeholders: false
      },
      validationSchema: yup.object().shape({
        includeStakeholders: yup.boolean()
      })
    },
    {
      name: 'Select Documents',
      initialValues: {
        documentIds: initialDocumentIds || [],
        documentIdsFilteredByDate: initialDocumentIds || [],
        documentsFilteredByDate: initialDocuments || [],
        insuredIdsFilteredByDate: initialInsuredIds || []
      },
      validationSchema: yup.object().shape({
        documentIds: yup.array().min(1).required('Required'),
        documentIdsFilteredByDate: yup.array()
      })
    },
    {
      name: 'Select Insureds',
      initialValues: {
        insuredIds: initialInsuredIds || [],
        insuredIdsFilteredByDocs: initialInsuredIds || []
      },
      validationSchema: yup.object().shape({
        insuredIds: yup.array().min(1).required('Required')
      })
    },
    {
      name: 'Confirm Download',
      initialValues: {},
      validationSchema: yup.object().shape({})
    }
  ];

  return { formSteps };
}
